module.exports = __webpack_public_path__ + "static/media/tabby.ac54ea09.png";